<template>
	<div class="dt-companies-filter-item flex max-w-[192px] flex-col">
		<el-dropdown popper-class="dt-companies-dropdown-filter" trigger="click" :hide-on-click="false" placement="bottom-start">
			<span class="el-dropdown-link flex h-10 w-full items-center gap-x-2 rounded-[5px] border border-solid border-dark_cyan px-3 py-1.5 font-roboto font-medium text-night_rider">
				<span class="block flex-1 truncate">
					<small v-if="filter.selectedSizes.length"> {{ filter.selectedSizes.length }} </small>
					Company Size
				</span>
				<el-icon class="el-icon--right !ml-0">
					<arrow-down class="fill-night_rider" />
				</el-icon>
			</span>
			<template #dropdown>
				<el-dropdown-menu>
					<el-dropdown-item class="d-flex flex-column align-items-start dropdown-search-item">
						<el-checkbox-group v-model="filter.selectedSizes" @change="onChange" :max="2">
							<el-checkbox v-for="size in props.sizes" :key="size.id" :label="size.name" :value="size.id" />
						</el-checkbox-group>
					</el-dropdown-item>
				</el-dropdown-menu>
			</template>
		</el-dropdown>
	</div>
</template>

<script setup lang="js">
import filter from "@/pages/Company/filter";
import { ArrowDown } from "@element-plus/icons-vue";
import { ref } from "vue";

const props = defineProps({
	sizes: { type: Array, default: () => [] },
});

const companySizeSearch = ref("");

const selectedSizes = ref([]);

const onChange = () => {
	filter.value.reload++;
};
</script>
